import AssetAssignedServiceOrderView from "@features/wx/dispatcher/components/assigned/view/AssignedAssetServiceOrderView";
import AssetCompletedServiceOrderViewPage from "@features/wx/dispatcher/components/completed/asset/assetCompletedServiceOrderView";
import AssetHistoryServiceOrderViewPage from "@features/wx/dispatcher/components/history/asset/assetHistoryServiceOrderView";
import AssetPendingServiceOrderView from "@features/wx/dispatcher/components/pending/view/AssetServiceOrderView";
import { RouteObject } from "react-router-dom";
import AddSchedule from "../schedule/components/create/components/create";
import ScheduleDetail from "../schedule/components/details/ScheduleDetails";
import Schedules from "../schedule/components/landing/schedule";
import { Landing } from "./components/landing/landing";
import CreateServiceOrder from "./components/management/create/createServiceOrder";

export interface axServiceOrder extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: axServiceOrder[];
}
export const axServiceOrder: axServiceOrder[] = [
  {
    path: "/ax/service-order/landing",
    element: <Landing />,
  },

  {
    path: "/ax/service-order/landing/create",
    element: <CreateServiceOrder />,
  },
  {
    path: "/ax/service-order/landing/edit/:id",
    element: <CreateServiceOrder />,
  },
  {
    path: "/ax/service-order/landing/pending/view/:serviceType/:id",
    element: <AssetPendingServiceOrderView />,
  },
  {
    path: "/ax/service-order/landing/assigned/view/:serviceType/:id",
    element: <AssetAssignedServiceOrderView />,
  },
  {
    path: "/ax/service-order/landing/completed/view/:serviceType/:id",
    element: <AssetCompletedServiceOrderViewPage />,
  },
  {
    path: "/ax/service-order/schedule",
    element: <Schedules />,
  },
  {
    path: "/ax/service-order/schedule/create",
    element: <AddSchedule />,
  },
  {
    path: "/ax/service-order/schedule/view/:id",
    element: <ScheduleDetail />,
  },
  {
    path: "/ax/service-order/landing/history/view/:serviceType/:id",
    element: <AssetHistoryServiceOrderViewPage />,
  },
];
